<template>
    <div :class="['page pay',{ off: !pageOn }]">
        <VHeader type="back" @back="pageOn = false;" />
        <div :class="['page-content', { copper: copper }]">
            <p v-if="!copper" style="text-align:center;font-size: 20px;margin-top:20px">Amount : {{ approve.price.toFixed(2) }}</p>
            <img v-if="copper" style="width: 100%;margin-top: 20px;margin-bottom: 15px;" src="/CopperPayTop-1.png" />
            <label>
                <p>Cardholder Name</p>
                <input placeholder="Cardholder Name" v-model="cardName" /> 
            </label>
            <div v-if="card" class="stored-card">
                <label>
                    <p>Card Number</p>
                    <div id="card-number-stored"><p>**** **** **** {{ card.last4 }}</p></div>
                </label>
                <div class="exp">
                    <label>
                        <p>Expiry MM</p>
                        <div id="exp-mm-stored"><p>{{ card.expMM }}</p></div>
                    </label>
                    <label>
                        <p>Expiry YY</p>
                        <div id="exp-yy-stored"><p>{{ card.expYY }}</p></div>
                    </label>
                    <label>
                        <p>CVV</p>
                        <div id="cvv-stored"><p>***</p></div>
                    </label>
                </div>
                <div class="v-btns">
                    <p class="btn change-card" style="width:120px;line-height:2;font-size: 14px;" @click="card = false">change card</p>
                    <p class="btn lg pay-stored">PAY</p>
                </div>
            </div>
            <div v-else style="width:100%;overflow:hidden">
                <label>
                    <p>Card Number</p>
                    <div id="card-number"></div>
                </label>
                <div class="exp">
                    <label>
                        <p>Expiry MM</p>
                        <div id="exp-mm"></div>
                    </label>
                    <label>
                        <p>Expiry YY</p>
                        <div id="exp-yy"></div>
                    </label>
                    <label>
                        <p>CVV</p>
                        <div id="cvv"></div>
                    </label>
                </div>
                <div class="v-btns">
                    <p class="btn lg pay-now">PAY</p>
                </div>
            </div>
            <Spinner v-if="spinner" @exit="spinner = false" />
        </div>
    </div>
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import Spinner from '@/components/Spinner.vue'
import { pageOn } from '@/utils/pageOn.js'
import WebSoc from '@/utils/WebSoc.js'
import Alert from '@/utils/Alert.js'
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
    name: 'pay',
    props: ['pay'],
    mixins: [ pageOn ],
    components: {
        VHeader,
        Spinner
    },
    data () {
        return {
            cardName: '',
            card: false,
            spinner: false,
            approve: {
                price: 0
            }
        }
    },
    computed: {
        copper () { return this.$store.state.copper }
    },
    mounted () {
        this.initPay();
        if ( this.copper ) {
            this.approve.price = this.copper.amount;
            this.cardName = this.copper.name;
        } else {
            this.approve.price = this.pay.amount;
        }
        
    },
    methods: {
        removeStoredCard () {
            this.card = false;
            WebSoc.SEND({ t: 'removeStoredCard' });
        },
        payFailed () {
            this.pageOn = false;
            this.pay.complete({ amount: 0, success: false })
        },
        paySuccess () {
            this.pageOn = false;
            this.pay.complete({ amount: this.approve.price, success: true })
        },
        initPay () {

            var { client_id, ad_id, approve_id } = this.pay;

            WebSoc.SEND({ t: 'getClientToken' },resp => {
            
            console.log('getClientToken',resp);

            if ( resp.savedCard ) { 
                this.card = resp.savedCard;
                this.cardName = this.card.cardholderName;
                return;
            }

            var clientToken = resp.clientToken;
             
            braintree.client.create({
                authorization: clientToken
                },(e,clientInstance) => {
                    if ( e ) console.log('clientInstance error ',e);
                    if ( e ) return Alert.messsage('There was a problem setting up the payment page');
                    if ( this.card ) { return this.payToken(); }
                
                    braintree.hostedFields.create({
                        client: clientInstance,
                        styles: {
                            input: {
                                'font-size': '20px',
                                'font-family': 'helvetica, tahoma, calibri, sans-serif',
                                'color': '#121212'
                            },
                            ':focus': {
                                color: 'black'
                            }
                        },
                        fields: {
                            number: {
                                selector: '.pay #card-number',
                                placeholder: 'Card Number'
                            },
                            cvv: {
                                selector: '.pay #cvv',
                                placeholder: 'CVV'
                            },
                            expirationMonth: {
                            selector: '.pay #exp-mm',
                            placeholder: 'MM'
                            },
                            expirationYear: {
                                selector: '.pay #exp-yy',
                                placeholder: 'YY'
                            } 
                        }
                    },(e,hostedFieldsInstance) => {
                        if ( this.card ) { return this.payToken(); }
                        if ( e ) console.log('hostedFieldsInatance error',e);
                        if ( e ) return Alert.message('There was a problem setting up the payment connection');
                        
                        this.$el.querySelector('.pay .pay-now').onclick = () => {

                            if ( !this.cardName ) { return Alert.message('You Must provide a Card Holder Name') } 

                            if ( this.spinner ) return;

                            this.spinner = true;

                            hostedFieldsInstance.tokenize((e,payload) => {
                                if ( e ) console.log(e);
                                if ( e ) {
                                    var fields = e.details && e.details.invalidFieldKeys;
                                    var message;
                                    if ( fields ) {
                                        if ( fields.indexOf('cvv') > -1 ) { message = 'Invalid CVV'; }
                                        if ( fields.indexOf('expirationYear') > -1 ) { message = 'Invalid Expiry Year'; }
                                        if ( fields.indexOf('expirationMonth') > -1 ) { message = 'Invalid Expiry Month'; }
                                        if ( fields.indexOf('number') > -1 ) { message = 'Invalid Card Number'; }
                                    }
                                    this.spinner = false;
                                    return Alert.message(message || 'There was a problem processing this payment'); 
                                }
                                
                                var createToken = false;
                                var approve = this.approve;
                                var cardName = this.cardName, that = this;
                                var { ad_id, client_id, approve_id } = this.pay;

                                !this.copper && Alert.yesno('Save Card Details',tokenize => {
                                    createToken = tokenize; 
                                    createPayment();
                                })
                                

                                var copper = this.copper;

                                var that = this;

                                copper && createPayment();

                                function createPayment() {

                                    if ( copper ) {
                                        /*
                                        setTimeout(() => {
                                            that.spinner = false;
                                            Alert.message('Your Payment has been successful',() => {
                                                that.goCopper();
                                            })
                                        },2000)
                                        */

                                        copper = JSON.parse(JSON.stringify(copper));

                                        copper.name = copper.name || cardName;

                                        WebSoc.SEND({ t: 'copperJoinTX', data: { copper: copper, tokenize: createToken, nonce: payload.nonce, cardholderName: cardName }},resp => {
                                            console.log('resp',resp);
                                            if ( resp.success ) {
                                                that.spinner = false;
                                                Alert.message('Your payment has been successful',() => {
                                                    that.goCopper();
                                                });
                                            } 
                                        })
                                    } else {

                                        WebSoc.SEND({ t: 'createTX', data: { client_id, ad_id, approve_id, tokenize: createToken, approve, nonce: payload.nonce, cardholderName: cardName }},resp => {
                                            that.exitPayment(resp);
                                        }) 

                                    } 
                                }

                            })
                        }
                    })
                })
            })
        },
        goCopper () {
            //this.popPage('pay');
            //this.popPage('copper-detail');
            //this.popPage('copper');
            this.$emit('goneCopper');
        },
        exitPayment (resp) {
            this.spinner = false;
            if ( resp.error ) { return Alert.message(resp.error); }
            if ( resp.success ) { this.payComplete(); }
            if ( resp.success ) { Alert.message('The payment was successful'); }
        },
        payComplete ( ) {
            this.pageOn = false;
            this.$emit('payComplete',{ amount: this.approve.price, success: true });
        },
        payToken () {

            this.$el.querySelector('.pay .pay-stored').onclick = () => {

                var { approve, cardName, card } = this;

                var { ad_id, client_id, approve_id } = this.pay;

                if ( !card ) return Alert.message('Stored Card Error');

                if ( this.spinner ) return;
                
                this.spinner = true;

                WebSoc.SEND({ t: 'createTX', data: { ad_id, client_id, approve_id, token: this.card, approve: this.approve, cardholderName: this.cardName }},resp => {
                    this.exitPayment(resp);
                })

            }
        }       
    }
}

</script>

<style lang="scss">
.rating {
    background-color: #434C5A;
}    
.pay {
.copper {
    p { color: white; }
}
label {
    width: 100%;
    > p { width: calc(100% - 20px) !important; }
    p { text-align: left; margin: 10px 10px 5px 15px; width: 100%; float: left; }
    input { font-family: helvetica, tahoma, calibri, sans-serif;  padding: 10px; border: 1px solid #c0c0c0; width: calc(95% - 30px); margin: 0px 15px; float: left; position: relative; }
    > div { padding: 0px 10px; border: 1px solid #c0c0c0; width: calc(95% - 30px); margin: 0px 15px; height: 45px; position: relative; float: left; }
}
div.exp {
    width: 100%;
    margin: 10px 0%;
    float: left;
    label {
        width: calc(33.333% - 5px);
        float: left;
        margin: 0px 0px;
        > p { font-size: 16px; margin: 0px 0px 5px 15px; padding: 0px; }
    }
}
div.v-btns { float: left; width: 100%; } 
}
#card-number,#exp-mm,#exp-yy,#cvv {
    background-color: white;
}
.container.html .new-pay.pay div.exp {
    label {
        p { margin: 3px 2px; }
    }
}
.page-content div.stored-card {
    float: left;
    label > div { background-color: white; font-family: helvetica, tahoma, calibri, sans-serif; font-size:20px;  }
   .v-btns .v-btn { width: calc(50% - 5%); float: left; }
}
</style>